export const pigeonSafetyFaq = [
  {
    question: "What are Pigeon Safety Nets made of?",
    answer:
      "Our pigeon safety nets are made from strong nylon material available in white and transparent options. They block pigeons effectively while keeping your view and airflow clear.",
  },
  {
    question: "What is the durability of pigeon safety nets?",
    answer:
      "White nylon nets generally last around 4–5 years, while transparent invisible nets are waterproof and provide a lifespan of up to 6–7 years.",
  },
  {
    question: "Are pigeon safety nets waterproof and weather resistant?",
    answer:
      "Yes, both net types are designed to withstand sunlight, rain, and outdoor conditions without losing strength or flexibility.",
  },
  {
    question: "Can pigeon safety nets be installed on balconies and windows?",
    answer:
      "Yes, these nets can be fitted on balconies, windows, ducts, ventilators, and other open areas to safely prevent pigeon entry.",
  },
];


export const petsSafetyFaq = [
  {
    question: "What material is used for pet and children safety nets?",
    answer:
      "We use high-quality Garware nets made from UV-stabilized nylon, offering strong impact resistance and long-term durability.",
  },
  {
    question: "What is the durability and thickness of pet safety nets?",
    answer:
      "These nets come in 2mm and 2.5mm thickness options, with an average lifespan of up to 8 years depending on usage and weather exposure.",
  },
  {
    question: "Can these nets protect children and pets from falling?",
    answer:
      "Yes, the nets are designed to handle heavy pressure and prevent kids or pets from slipping through balcony gaps or open spaces.",
  },
  {
    question: "What colors are available for pet safety nets?",
    answer:
      "The nets are available in green and white colors, giving a neat and natural look that blends with your balcony or terrace.",
  },
];


export const invisibleGrillFaq = [
  {
    question: "What are invisible grills made of?",
    answer:
      "Invisible grills are made using marine-grade SS 316 stainless steel wires coated with nylon for strength, durability, and corrosion resistance.",
  },
  {
    question: "How strong are invisible grills?",
    answer:
      "They provide high tensile strength of around 400 kg and can handle heavy impact loads, making them suitable for high-rise safety.",
  },
  {
    question: "What is the wire thickness and spacing of invisible grills?",
    answer:
      "Invisible grill wires are available in 2mm, 2.5mm, and 3mm thickness options with a standard spacing of 2 inches between each cable.",
  },
  {
    question: "How long do invisible grills last?",
    answer:
      "With marine-grade materials and weather-resistant coating, invisible grills generally last up to 20 years.",
  },
  {
    question: "How are invisible grills installed?",
    answer:
      "They are installed using strong aluminum frames, SS 316 wires, screws, clamps, and safety clips. Cross support lines are added every 3.5 feet for extra stability.",
  },
];
